"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ALERT_DISPLAY_TYPE", {
  enumerable: true,
  get: function () {
    return _Alert.ALERT_DISPLAY_TYPE;
  }
});
Object.defineProperty(exports, "ALERT_SIZE", {
  enumerable: true,
  get: function () {
    return _Alert.ALERT_SIZE;
  }
});
Object.defineProperty(exports, "ALERT_STYLE_TYPE", {
  enumerable: true,
  get: function () {
    return _Alert.ALERT_STYLE_TYPE;
  }
});
exports.Alert = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ButtonIcon = require("b2b-components/theme/components/ButtonIcon");
var _Icon = require("b2b-components/theme/components/Icon");
var _upperCase = require("b2b-components/utils/upperCase");
var _classnames = _interopRequireDefault(require("classnames"));
var _Alert = require("./Alert.types");
require("./Alert.scss");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Alert = _ref => {
  let {
    children,
    title,
    displayType = _Alert.ALERT_DISPLAY_TYPE.box,
    styleType = _Alert.ALERT_STYLE_TYPE.info,
    size = _Alert.ALERT_SIZE.default,
    isDismissible = false,
    onClose,
    className,
    iconClassName,
    actionButton
  } = _ref;
  const [isVisible, setIsVisible] = (0, _react.useState)(true);
  const handleClose = () => {
    onClose?.();
    setIsVisible(false);
  };
  if (!isVisible) {
    return null;
  }
  const rootClassName = (0, _classnames.default)('cds-Alert', `cds-Alert--${(0, _upperCase.upperCaseFirst)(displayType)}`, `cds-Alert--${(0, _upperCase.upperCaseFirst)(styleType)}`, {
    [`cds-Alert--${(0, _upperCase.upperCaseFirst)(size || '')}`]: size !== _Alert.ALERT_SIZE.default,
    'cds-Alert--Dismissable': isDismissible
  }, className);
  const iconName = `IconAlert${(0, _upperCase.upperCaseFirst)(styleType)}`;
  const iconClassNames = (0, _classnames.default)('cds-Alert-Icon', iconClassName);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Alert-Content"
  }, displayType === _Alert.ALERT_DISPLAY_TYPE.notification ? /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: iconClassNames,
    name: _Icon.ICON_NAME.alertNotification
  }) : /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: iconClassNames,
    name: iconName
  }), /*#__PURE__*/_react.default.createElement("div", null, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Alert-Title"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Alert-Content"
  }, children))), isDismissible && /*#__PURE__*/_react.default.createElement(_ButtonIcon.ButtonIcon, {
    className: "cds-Alert-ButtonClose cds-AlertClose",
    icon: _ButtonIcon.BUTTON_ICON_ICON_NAME.close,
    size: _ButtonIcon.BUTTON_ICON_SIZE.medium,
    styleType: _ButtonIcon.BUTTON_ICON_STYLE_TYPE.ghost,
    onClick: handleClose
  }), !isDismissible && actionButton && /*#__PURE__*/_react.default.createElement("div", {
    className: "cds-Alert-ActionButton"
  }, actionButton));
};
exports.Alert = Alert;
//# sourceMappingURL=Alert.js.map